import React, { useState } from "react";
import { Button, Card, Input, Spin, Table } from "antd";
import { FiFilter } from "react-icons/fi";
import { IoClose } from "react-icons/io5";
import { FiFileText } from "react-icons/fi";

const NotBillableColumnGraph = ({
  nonBillCount,
  xPreviousMonth,
  setXPreviousMonth,
  loading,
}) => {

  const [filterPopUp, setFilterPopUp] = useState(false);
  const [inputValue, setInputValue] = useState(1);
  const [error, setError] = useState(false);

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (
      value === "" ||
      (/^\d*$/.test(value) && value.length <= 2 && parseInt(value, 10) > 0)
    ) {
      setInputValue(value);
    }
  };

  const handleApply = () => {
    if (!inputValue || inputValue.trim() === "") {
      setError(true);
      return;
    }
    setError(false); 
    setXPreviousMonth(inputValue);
    setFilterPopUp(false);
  };

  const columns = [
    {
      title: "S. No.",
      dataIndex: "id",
      render: (_, __, index) => index + 1,
      width: 60,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 230,
      
    },
    {
      title: "Team",
      dataIndex: "team",
      key: "team",
      width: 70,
    },
  ];

  return (
    <Card style={{ border: "1px solid #0000001F", borderRadius: "16px" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          position: "relative",
        }}
      >
        <div
          style={{
            fontWeight: "700",
            fontSize: "16px",
            padding: "0px 8px 4px 8px",
          }}
        >
          Non-Billable in Last{" "}
          <span style={{ color: "red" }}>
            {xPreviousMonth ? xPreviousMonth : 10}
          </span>{" "}
          Months
        </div>
        <Button
          icon={<FiFilter />}
          onClick={() => setFilterPopUp(!filterPopUp)}
          style={{
            backgroundColor: "#68B0DA4D",
            border: "none",
            borderRadius: "4px",
          }}
        ></Button>

        {filterPopUp && (
          <div
            style={{
              width: "200px",
              height: "fit-content",
              border: "1px solid #0000001F",
              borderRadius: "6px",
              position: "absolute",
              zIndex: "5",
              right: "0px",
              top: "34px",
              backgroundColor: "#FFFFFF",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                height: "35px",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "0px 12px",
              }}
            >
              <span>Enter No. of Months</span>{" "}
              <span
                style={{ cursor: "pointer" }}
                onClick={() => setFilterPopUp(false)}
              >
                {<IoClose />}
              </span>
            </div>
            <div style={{ padding: "0px 12px" }}>
              <Input
                style={{
                  width: "100%",
                  borderColor: error ? "red" : "#d9d9d9",
                }}
                value={inputValue}
                onChange={(e) => {
                  setError(false);
                  handleInputChange(e);
                }}
                maxLength={2}
              />
              {error && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  Please enter a valid number
                </span>
              )}
            </div>
            <div
              style={{
                padding: "6px 12px",
                gap: "8px",
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Button
                style={{
                  color: "#FFFFFF",
                  border: "0px",
                  backgroundColor: "#05539B",
                  width: "40%",
                }}
                onClick={handleApply}
              >
                Apply
              </Button>
            </div>
          </div>
        )}
      </div>

      {loading ? (
        <span
          style={{
            display: "flex",
            justifyContent: "center",
            height: "332px",
            alignItems: "center",
          }}
        >
          <Spin />
        </span>
      ) : (
        <>
          {nonBillCount.length === 0 ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                height: "325px",
                color: "#9B9DA0",
                fontWeight: "700",
              }}
            >
              <span>
                <FiFileText style={{ fontSize: "60px" }} />
              </span>
              <span>No data available</span>
            </div>
          ) : (
            <div
              style={{
                minHeight: "325px",
                maxHeight: "325px",
                overflow: "auto",
                padding: "2px",
                marginTop: "5px",
              }}
            >
              <Table
                dataSource={nonBillCount}
                columns={columns}
                scroll={{ x: 200, y: 280 }}
                pagination={false}
                rowKey="employeeNo"
                size="small"
              />
            </div>
          )}
        </>
      )}
    </Card>
  );
};

export default NotBillableColumnGraph;
